import { render, staticRenderFns } from "./ExperimentComponent.vue?vue&type=template&id=078285b1&scoped=true&lang=html&"
import script from "./ExperimentComponent.vue?vue&type=script&lang=js&"
export * from "./ExperimentComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExperimentComponent.vue?vue&type=style&index=0&id=078285b1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078285b1",
  null
  
)

export default component.exports